/**
 * da-gallery-rail.js — Dev Aastha
 *
 * PDP gallery ke baayen taraf thumbnail rail.
 *
 * ---------------------------------------------------------------------------
 * Zaroorat kyun
 * ---------------------------------------------------------------------------
 * Ella ka apna inline thumbnail rail is theme par KHALI render hota hai —
 * `.swiper-controls__thumbnails-container` maujood to hai (412px chauda) par
 * uske andar 0 slides aur 0 images hain, height 0. (Zoom dialog wale thumbnails
 * theek kaam karte hain — sirf inline wale khali hain.)
 *
 * ---------------------------------------------------------------------------
 * ⚠ Purana rail kyun HATANA pada — aur ye usse alag kaise hai
 * ---------------------------------------------------------------------------
 * Pehle ka rail (jo `sections/da-pdp-v2.liquid` me inline tha) khud
 * `.swiper-wrapper` par `translate3d` set karta tha, kyunki tab maana gaya tha
 * ki Ella ki swiper chalti hi nahi. Wo maan-na galat tha — swiper chalti hai,
 * bas `deferUntilInteraction` + `Motion.inView` ke baad shuru hoti hai.
 *
 * Nateeja: do cheezein ek hi wrapper ko kheech rahi thi. Asli Chrome me naapa —
 * `slideTo(2)` par turant `activeIndex 2, translate -1070` (swiper ka kaam),
 * aur ~260ms baad wapas `0, 0` (purane rail ka `slideTo(0)`). Shopper ko image
 * "slide hoke wapas pehli par" aati dikhti thi.
 *
 * Isliye YE rail swiper ke transform ko HAATH NAHI LAGATA. Ye sirf do kaam
 * karta hai:
 *   · thumb par click  ->  swiper.slideTo(i)   (uska apna API)
 *   · active highlight ->  `.swiper-slide-active` class dekh kar
 * Koi transform, koi update(), koi timing hack. Swiper malik, ye sirf remote.
 */
(function () {
  'use strict';

  var RAIL_CLASS = 'da-gal-rail';

  function build() {
    var media = document.querySelector('.product-information__media');
    if (!media || media.querySelector('.' + RAIL_CLASS)) return false;

    var main = media.querySelector('.swiper-main');
    if (!main) return false;

    var slides = [].slice.call(main.querySelectorAll('.swiper-slide'));
    if (slides.length < 2) return false;

    var rail = document.createElement('div');
    rail.className = RAIL_CLASS;

    slides.forEach(function (slide, i) {
      var img = slide.querySelector('img');
      if (!img) return;

      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Image ' + (i + 1));
      b.dataset.daIdx = String(i);

      var t = document.createElement('img');
      /* thumbnail ke liye chhoti file maango — asli src par Shopify ka width
         param badal dete hain, warna har thumb poori badi image download karta */
      var src = img.getAttribute('src') || '';
      t.src = src.replace(/([?&])width=\d+/, '$1width=160');
      t.alt = '';
      t.loading = 'lazy';
      t.decoding = 'async';
      b.appendChild(t);

      b.addEventListener('click', function () {
        /* swiper der se banti hai (interaction ke baad), isliye instance CLICK
           ke waqt dhoondho — load ke waqt nahi */
        var sw = main.swiper;
        if (sw && typeof sw.slideTo === 'function') {
          sw.slideTo(i);
        } else {
          /* swiper abhi nahi bani — slide ko apne scroll container me le aao */
          try { slide.scrollIntoView({ block: 'nearest', inline: 'start' }); } catch (e) {}
        }
        mark(i);
      });

      rail.appendChild(b);
    });

    if (!rail.children.length) return false;

    /* ⚠ Rail ko `media-gallery` ke ANDAR mat daalna — `.flag` aur `.imgacts`
       overlay `inset:0` par uske sapeksh baithe hain, wo rail par bhi phail
       jaate. Isliye rail uska BHAI hai. */
    media.insertBefore(rail, media.firstChild);

    mark(activeIndex(main));
    watch(main);
    return true;
  }

  function activeIndex(main) {
    var slides = [].slice.call(main.querySelectorAll('.swiper-slide'));
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('swiper-slide-active')) return i;
    }
    return 0;
  }

  function mark(i) {
    var rail = document.querySelector('.' + RAIL_CLASS);
    if (!rail) return;
    [].forEach.call(rail.children, function (b, n) {
      if (n === i) b.setAttribute('aria-current', 'true');
      else b.removeAttribute('aria-current');
    });
  }

  /* Highlight swiper ke apne `.swiper-slide-active` se aata hai — uske event
     API par nirbhar nahi, taaki swiper kabhi na bane to bhi kuch toote na. */
  function watch(main) {
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { mark(activeIndex(main)); }, 50);
    }).observe(main, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  function start() {
    if (build()) return;
    /* gallery baad me render ho sakti hai — thodi der try karo, phir chhod do */
    var n = 0;
    var iv = setInterval(function () {
      if (build() || ++n > 20) clearInterval(iv);
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
